const _ = (key) => `calendar/${key}`;


export const FIRST_DAY      = _('firstDay');
export const NEXT_FIRST_DAY = _('nextFirstDay');
export const PREV_FIRST_DAY = _('prevFirstDay');



// WEBPACK FOOTER //
// ./src/core/store/calendar/types/getters.js